import SplitMedia from "./SplitMedia";

export default SplitMedia;
